import { DepartmentEnum } from "./transaction";

export const DepartmentName = {
  [DepartmentEnum.PHUOC_THANH]: "Phước Thạnh",
  [DepartmentEnum.THAI_MY]: "Thái Mỹ",
  [DepartmentEnum.OTHER]: "Khác",
  [DepartmentEnum.PHUOC_THANH_2]: "Phước Thạnh 2",
};
